// Routes Component
import React from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { urlFormatter } from '../util';
import {
  getStorageElement,
  removeStorageElement,
} from 'services/storage.service';

class Routes extends React.Component {
  constructor(props) {
    super(props);
    this.changed = false;
    this.routesObj = null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const currentPath = window.location.pathname;
    if (
      nextProps.routes !== this.props.routes ||
      currentPath !== window.location.pathname
    ) {
      return true;
    }
    return false;
  }

  getTemplatePath = (routeElem) => {
    return routeElem?.template?.split('-').join('/');
  };

  getCurrentRoute = () => {
    if (Array.isArray(this.props.routes[this.props.currentRoute.id])) {
      let currentPathName = this.props.location.pathname.substr(4);
      let currentPathSubLevels = (currentPathName.match(/\//g) || []).length;

      let routesLength = this.props.routes[this.props.currentRoute.id].length;
      for (let i = 0; i < routesLength; i++) {
        let routeSubLevels = (
          this.props.routes[this.props.currentRoute.id][i].route.match(
            /\/:/g
          ) || []
        ).length;
        if (routeSubLevels === currentPathSubLevels) {
          return this.props.routes[this.props.currentRoute.id][i].route;
        }
      }
    } else {
      return this.props.routes[this.props.currentRoute.id].route;
    }
  };

  savedUrlRedirect = () => {
    const currentPath = window.location.pathname;
    const decodedURL = decodeURIComponent(currentPath);
    if (
      decodedURL === '/ar/الشروط-و-الاحكام' ||
      decodedURL === '/ar/الشروط-و-الاحكام/'
    ) {
      this.props.history.push(
        urlFormatter(this.props.routes['informative-terms']['route'])
      );
    } else if (decodedURL === '/ar/المتاجر/' || decodedURL === '/ar/المتاجر') {
      this.props.history.push(
        urlFormatter(this.props.routes['informative-stores']['route'])
      );
    } else if (
      decodedURL === '/ar/شكوى-العميل' ||
      decodedURL === '/ar/شكوى-العميل/'
    ) {
      this.props.history.push(
        urlFormatter(
          this.props.routes['informative-customer_complaints']['route']
        )
      );
    }
  };

  render() {
    let iso = this.props.iso;
    let redirect = null;
    this.savedUrlRedirect();
    if (this.changed && this.props.currentRoute) {
      if (this.props.currentRoute.url) {
        redirect = <Redirect to={'/' + iso + this.props.currentRoute.url} />;
      } else {
        if (this.props.currentRoute.name === 'home') {
          redirect = <Redirect to={'/' + iso + '/'} />;
        } else {
          let currentRoute = this.getCurrentRoute();
          let currentRouteIndexOf = currentRoute.indexOf('/:');
          if (currentRouteIndexOf !== -1) {
            let txtUrl = currentRoute.substring(0, currentRouteIndexOf);
            if (this.props.currentRoute.slug) {
              currentRoute = txtUrl + '/' + this.props.currentRoute.slug + '/';
            } else {
              currentRoute = txtUrl + '/';
            }
          }

          if (
            currentRoute === 'bundle-details/' ||
            currentRoute === 'bundle-details'
          ) {
            this.props.history.push(
              urlFormatter(`${currentRoute}${this.props.bundleRedirect}`)
            );
          } else {
            redirect = (
              <Redirect
                to={{
                  pathname: `/${iso}/${currentRoute}`,
                  search: `${window.location.search}`,
                }}
              />
            );
          }
        }
      }
      this.changed = false;
    }

    const loggedIn = getStorageElement('loggedIn');
    const routing = Object.keys(this.props.routes).map((key) => {
      const route = this.props.routes[key];
      let templatePath = null;
      let C = null;

      if (Array.isArray(route) && route.length) {
        return route.map((routeElem) => {
          templatePath = this.getTemplatePath(routeElem);
          C = React.lazy(() =>
            import(
              /* webpackChunkName: "[request]" */ `../pages/${templatePath}`
            )
          );
          return (
            <Route
              key={route.id}
              path={`/:lang/${routeElem.route}`}
              exact={true}
              render={(props) => {
                const loggedIn = getStorageElement('loggedIn');
                if (routeElem.protected && !loggedIn) {
                  return (
                    <Redirect
                      to={{
                        pathname: urlFormatter(
                          this.props.routes['informative-login']['route']
                        ),
                        state: { from: props.location }, // Pass the current location for post-login redirection
                      }}
                    />
                  );
                } else if (
                  loggedIn &&
                  props.location.state &&
                  props.location.state.from
                ) {
                  // Handle redirect after login and clear session
                  removeStorageElement('redirectState'); // Clear session storage after redirect
                  return (
                    <Redirect
                      to={{
                        pathname: props.location.state.from.pathname,
                        state: {
                          balanceTransferId:
                            props.location.state.balanceTransferId,
                        },
                      }}
                    />
                  );
                }

                return <C {...props} routeId={routeElem.template} />;
              }}
            />
          );
        });
      } else {
        templatePath = this.getTemplatePath(route);
        C = React.lazy(() =>
          import(/* webpackChunkName: "[request]" */ `../pages/${templatePath}`)
        );

        return (
          <Route
            key={route.id}
            path={`/:lang/${route.route}`}
            exact={true}
            render={(props) => {
              const loggedIn = getStorageElement('loggedIn');
              if (route.protected && !loggedIn) {
                return (
                  <Redirect
                    to={{
                      pathname: urlFormatter(
                        this.props.routes['informative-login']['route']
                      ),
                      state: { from: props.location }, // Pass the current location for post-login redirection
                    }}
                  />
                );
              } else if (
                loggedIn &&
                props.location.state &&
                props.location.state.from
              ) {
                // Handle redirect after login and clear session
                removeStorageElement('redirectState'); // Clear session storage after redirect
                return (
                  <Redirect
                    to={{
                      pathname: props.location.state.from.pathname,
                      state: {
                        balanceTransferId:
                          props.location.state.balanceTransferId,
                      },
                    }}
                  />
                );
              }

              return <C {...props} routeId={route.template} />;
            }}
          />
        );
      }
    });

    const redirects = Object.keys(this.props.redirects).map((key) => {
      let redirect = this.props.redirects[key];
      return (
        <Route
          key={redirect.id}
          path={'/' + redirect.route}
          exact={true}
          render={(props) => {
            return <Redirect to={`/${iso}/${redirect.rewrite_url}`} />;
          }}
        />
      );
    });

    return (
      <>
        {redirect}
        <Switch>
          {redirects}
          {routing}
          <Route
            path={`/${iso}/`}
            exact={true}
            key={9999}
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[home]" */ `../pages/informative/home`
                )
              );

              return <C {...props} routeId={'informative-home'} />;
            }}
          />

          <Route
            path="/"
            exact={true}
            render={() => <Redirect to={`/${iso}/`} />}
          />

          <Route
            key={901}
            path={`/:lang/absher-validation`}
            exact={true}
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[AbsherValidation]" */ `../pages/informative/register_sim/AbsherValidation`
                )
              );

              return <C {...props} />;
            }}
          />

          <Route
            key={9010}
            path={`/:lang/esim-activation-success/:orderId`}
            exact={true}
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[esim_activation_success]" */ `../pages/shop/esim/esim_activation_success`
                )
              );

              return <C {...props} />;
            }}
          />

          <Route
            path={`/${iso}/faq_category/:categoryId`}
            exact={true}
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[request]" */ `../pages/informative/support/category`
                )
              );

              return <C {...props} />;
            }}
          />
          <Route
            path={`/${iso}/faq/:postId`}
            exact={true}
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[request]" */ `../pages/informative/support/post`
                )
              );

              return <C {...props} />;
            }}
          />
          <Route
            path={`/${iso}/payment`}
            exact={true}
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[request]" */ `../pages/informative/payment`
                )
              );

              return <C {...props} />;
            }}
          />

          <Route
            render={(props) => {
              let C = React.lazy(() =>
                import(
                  /* webpackChunkName: "[Common404]" */ `../pages/informative/404`
                )
              );

              return <C {...props} />;
            }}
          />
        </Switch>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    iso: state.layout.iso,
    currentRoute: state.layout.currentRoute,
    bundleRedirect: state.layout.bundleRedirect,
    routes: state.layout.routes,
    redirects: state.layout.redirects,
    loading: state.layout.loading,
    loggedIn: state.user.loggedIn,
  };
};

export default withRouter(connect(mapStateToProps)(Routes));
